<button
  type="button"
  class="chip"
  [style.background]="currentItem().bg"
  [style.color]="currentItem().text"
  [attr.aria-haspopup]="'listbox'"
  [attr.aria-expanded]="isOpen()"
  (click)="toggle()"
>
  <span class="chip-dot" [style.background]="currentItem().dot"></span>
  <span class="chip-label">{{ currentItem().label }}</span>
  <span class="chip-caret" [class.open]="isOpen()" aria-hidden="true"></span>
</button>

@if (isOpen()) {
  <div class="backdrop" (click)="close()"></div>
  <div
    class="menu"
    role="listbox"
    [style.top.px]="menuPosition()?.top"
    [style.left.px]="menuPosition()?.left"
  >
    @for (item of items(); track item.value) {
      <button
        type="button"
        class="menu-item"
        role="option"
        [attr.aria-selected]="item.value === current()"
        (click)="select(item.value)"
      >
        <span class="chip-dot" [style.background]="item.dot"></span>
        <span class="menu-label">{{ item.label }}</span>
        @if (item.value === current()) {
          <span class="menu-check" aria-hidden="true">✓</span>
        }
      </button>
    }
  </div>
}
